module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw",
    attrs: {
      "epub:type": "frontmatter epigraph",
      "id": "epigraph"
    }
  }, [_c('h1', {
    staticClass: "preface-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("If you bring forth what is within you,"), _c('br'), _vm._v("what you bring forth will save you.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("If you do not bring forth what is within you,"), _c('br'), _vm._v("what you do not bring forth will destroy you.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution1"
  }, [_c('a', {
    attrs: {
      "id": "page-ix"
    }
  }), _vm._v("—T"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("OSPEL OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HOMAS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 69
// module chunks = 0